module.exports = __webpack_public_path__ + "static/media/icon-moduleE2.e4312577.png";